<div class="st-compact-card" [style.border-left-color]="priorityBorderColor" (click)="onCardClick($event)">
  <div class="st-compact-card-name">{{ subtask.name }}</div>

  <!-- Priority + Type chips. Same palette as the main kanban card chips but
       intentionally smaller (font-size 9px vs 11px). Hidden via *ngIf when
       neither piece of metadata is present. -->
  <div class="st-card-chips" *ngIf="getPriorityName() || getTaskTypeName()">
    <span *ngIf="getPriorityName()"
      class="st-chip"
      [ngClass]="getPriorityClass()">
      {{ getPriorityName() }}
    </span>
    <span *ngIf="getTaskTypeName()" class="st-chip st-type-chip">
      {{ getTaskTypeName() }}
    </span>
  </div>

  <!-- Meta row: stacked assignee avatars only. The due date is rendered
       below on its own `.st-card-due` line (matches the main kanban card),
       so the old inline `.st-compact-date` span has been removed. -->
  <div class="st-compact-card-meta" *ngIf="getAssignees().length > 0">
    <div class="st-card-avatars">
      <div class="st-avatar"
        *ngFor="let email of getAssignees().slice(0, 2)"
        [matTooltip]="email">
        {{ getInitials(email) }}
      </div>
      <div class="st-avatar st-avatar-more" *ngIf="getAssignees().length > 2">
        +{{ getAssignees().length - 2 }}
      </div>
    </div>
  </div>

  <!-- Entity tags (Patient/Prescriber/SOC). Renders only when tag objects with
       category_name are present. TODO: Resolve tag IDs to names once tag lookup
       is wired through TaskMgmtService. -->
  <div class="st-card-tags" *ngIf="entityTags.length > 0">
    <span *ngFor="let tag of entityTags.slice(0, 2)"
      class="st-entity-tag"
      [ngClass]="{
        'st-tag-patient': (tag.category_name || '').toUpperCase() === 'PATIENT',
        'st-tag-prescriber': (tag.category_name || '').toUpperCase() === 'PRESCRIBER',
        'st-tag-soc': (tag.category_name || '').toUpperCase() === 'SOC'
      }">
      {{ tag.tag_name }}
    </span>
    <span *ngIf="entityTags.length > 2" class="st-entity-tag st-tag-more">
      +{{ entityTags.length - 2 }}
    </span>
  </div>

  <!-- Due date / overdue line -->
  <div class="st-card-due" *ngIf="subtask.endDate" [class.overdue]="isOverdue">
    Due {{ formatDueDate(subtask.endDate) }}<span *ngIf="isOverdue"> · Overdue</span>
  </div>

  <!-- Comment + Attachment badge row — icons always visible, count shown only when > 0 -->
  <div class="st-card-badge-row">
    <span class="st-card-badge-spacer"></span>
    <button type="button" class="st-card-attach-btn"
      (click)="onAttachmentsClick($event)" matTooltip="Attachments">
      <mat-icon class="st-card-badge-icon">attach_file</mat-icon>
      <span class="st-card-badge-count" *ngIf="getAttachmentCount() > 0">{{ getAttachmentCount() }}</span>
    </button>
    <button type="button" class="st-card-comment-btn"
      (click)="onCommentsClick($event)" matTooltip="Comments">
      <svg width="10" height="10" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"
        style="vertical-align:middle">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
      </svg>
      <span class="st-card-badge-count" *ngIf="getCommentCount() > 0">{{ getCommentCount() }}</span>
    </button>
  </div>
</div>
